import Page from "../../../components/Page";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { birthdateState, nameState, phoneNumberState, providerState } from "../../../../atom/simpleCert";
import { providers } from "../../../../constants/simple-cert";
import UserInfo from "./UserInfo";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../constants/routes";
import React, { useEffect, useState } from "react";
import Agreements from "./Agreements";
import Button from "../../../components/Button";
import axios from "axios";
import { optionState, trxState, useAlert } from "../../../../atom/common";
import ecdh from "../../../../lib/ecdh";

interface requestProps {
    provider_id: string;
    name: string;
    phone: string;
    birthday: string;
    service_code: string;
    device_type: string;
    trigger_type: string;
    sign_content?: string;
    sign_type?: string;
}

export interface commonProps {
    code: string;
    message?: string;
}

interface responseProps extends commonProps {
    code: string;
    message?: string;
    client_tx_id: string;
    server_tx_id: string;
    app_scheme?: string;
}

export function Request() {
    const alert = useAlert();
    const [userInfo, setUserInfo] = useState(false);
    const [agreed, setAgreed] = useState(false);
    const provider = useRecoilValue(providerState);
    const navigate = useNavigate();
    const { service_code, device_type, trigger_type, token, sign_type, sign_content, default_provider } = useRecoilValue(optionState);
    const setTrx = useSetRecoilState(trxState);

    const name = useRecoilValue(nameState);
    const birthdate = useRecoilValue(birthdateState);
    const phoneNumber = useRecoilValue(phoneNumberState);

    useEffect(() => {
        if (!provider) navigate(routes.home);
    }, [navigate]);

    if (!provider) return null;

    const prev = () => {
        navigate(routes.home)
    }

    const request = () => {
        const data: requestProps = {
            "provider_id": provider,
            "name": name,
            "phone": phoneNumber,
            "birthday": birthdate,
            "service_code": service_code || "AUTH",
            "device_type": device_type || getDeviceTypeEnhanced(),
            "trigger_type": trigger_type || "PUSH"
        }

        if (service_code === "SIGN" || service_code === "WITHDRAWAL") {
            data.sign_content = sign_content
            data.sign_type = sign_type || "";
        }

        axios.post<responseProps>("/kiap-service/api/v1/request", data, { headers: { Authorization: `Bearer ${token}` } }
        )
            .then(response => {
                let { client_tx_id, server_tx_id, app_scheme } = response.data;
                setTrx({ client_tx_id, server_tx_id });
                if (app_scheme) {
                    if (provider === "NAVER" && typeof window.NaverSign == 'undefined') {
                        app_scheme += "&closeApp=true";
                    }

                    if (window.opener) window.location.href = app_scheme;
                    else window.parent.postMessage({ code: "K0000", message: "성공", func: "lunch_app", param: JSON.stringify({ app_scheme }) }, "*");
                }
                navigate(routes.simpleCert.confirm);
            })
            .catch(error => {
                const { code, message } = error.response.data;
                alert(code, message)
            })
    }

    return (
        <Page>
            <Page.Header />
            <Page.Content>
                <Page.Title title={`${providers[provider].text}로 인증합니다`} description="본인정보를 입력해 주세요" />
                <UserInfo setValidity={setUserInfo} />
                <Agreements setValidity={setAgreed} />
                <Button confirm={request} prev={default_provider ? undefined : prev} disabled={!userInfo || !agreed || !(name && birthdate && phoneNumber)}>인증하기</Button>
            </Page.Content>
        </Page>
    )
}


function getDeviceTypeEnhanced() {
    const ua = navigator.userAgent;
    const maxTouchPoints = navigator.maxTouchPoints || 0;

    if ((ua.includes('Macintosh') && maxTouchPoints > 1)) {
        return "TB";
    }

    if (/(tablet|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "TB";
    }

    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        if (ua.includes('iPad')) return "TB";
        return "MO";
    }

    return "PC";
}